import React from "react";
import ButtonLoader from "../Icons/ButtonLoader";

const OverlayLoader = ({ className }) => {
  return (
    <div>
      <div
        className={`fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black z-[99999] ${className}`}
      >
        <ButtonLoader className="h-[40px] w-[40px]" />

        <div className="text-white text-[16px]font-medium font-lexend mt-5 animate-pulse">
          Getting things ready for you...
        </div>
      </div>
    </div>
  );
};

export default OverlayLoader;
